import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'
import { IdCategoriesState } from 'model/dashboardCategories/dCategoriesReducer'

import { typeDataCategoriesBulkActions } from '../index';

import { InputCheckbox } from 'components/UI/InputCheckbox/InputCheckbox';
import {
    dCategoriesCheckedAllItemAC,
    dCategoriesCheckedItemAC
} from 'model/dashboardCategories/dCategoriesActionCreators';
import { DotsVerticalIcon } from '@heroicons/react/outline';

// Type
export type typeTableHeader = {
    variant?: string
    bulkActions: typeDataCategoriesBulkActions
}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = ( { variant, bulkActions } ) => {
    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector(( state: { dCategories: IdCategoriesState } ) => state.dCategories.data)
    const groupActions = tableData.find(item => item.checked)

    const checkedAll = () => {
        dispatch(dCategoriesCheckedAllItemAC(true))
    }

    const unCheckedAll = () => {
        dispatch(dCategoriesCheckedAllItemAC(false))
    }
    return (
        <>
            {!groupActions
                ? <>
                    <th scope="col"
                        className="px-4 py-3  w-4 text-center text-xs font-medium uppercase tracking-wider ">
                        <InputCheckbox id="selectAll" checked={false} onChange={() => checkedAll()}/>
                    </th>
                    <th scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                        <Trans> Name</Trans>
                    </th>
                    <th scope="col"
                        className="w-1 ">

                    </th>
                </>
                : <>
                    <th scope="col"
                        className=" px-4 py-3 w-4  text-xs font-medium uppercase tracking-wider text-center  cursor-pointer">
                        <div className="flex justify-center" onClick={() => unCheckedAll()}>
                            <div
                                className={`flex flex-col justify-center items-center h-4 w-4 text-white focus:ring-white border border-gray-100 rounded bg-${color}-600`}>
                                <div className="h-0.5 w-2 my-1 bg-white rounded"/>
                            </div>
                        </div>
                    </th>
                    <th colSpan={2} className="py-3 text-sm">
                        <div className="flex divide-x divide-gray-300">
                            {bulkActions.map(( actionItem, ActionIndex ) =>
                                <ButtonLink key={ActionIndex} type={"button"}
                                            dark={true}
                                            label={actionItem.title}
                                            buttonClassName={'text-gray-700'}
                                            onClick={() => actionItem.action()}
                                />
                            )
                            }
                        </div>
                    </th>
                </>
            }

        </>
    )
}

// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: ( id: string ) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
}

// Body data component
export const TableBody: React.FC<typeTableBody> = ( { variant, rowsActions } ) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector(( state: { dCategories: IdCategoriesState } ) => state.dCategories.data)

    let component

    const onChangeSelectItemHandler = ( id: string ) => {
        dispatch(dCategoriesCheckedItemAC(id))
    }

    if (tableData.length) {
        component = tableData.map(( item, index ) => {
            return (
                <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`}>
                    <td className="px-4 py-3  whitespace-nowrap text-sm text-gray-500">
                        <div className="flex justify-center">
                            <InputCheckbox
                                id={'select-' + item.id}
                                checked={item.checked}
                                onChange={() => onChangeSelectItemHandler(item.id)}
                            />
                        </div>
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                        {item.name}{item.deleted ? ' ' : null}{item.deleted ?
                        <span className="text-xs text-gray-400 font-normal"><Trans>(deleted)</Trans></span> : null}
                    </td>

                    <td className=" whitespace-nowrap text-sm text-gray-500 pr-2 w-1">
                        <div className="relative flex ">
                            <div
                                className="row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button"/>
                                <div
                                    className="row-action-list">
                                    <div className="flex gap-x-4">
                                        {rowsActions.map(( actionItem, ActionIndex ) => {
                                                const link = <ButtonLink key={ActionIndex} type={"button"}
                                                                         label={actionItem.title}
                                                                         onClick={() => actionItem.action(item.id)}/>
                                                if ('id' in actionItem) {
                                                    // @ts-ignore
                                                    switch (actionItem.id) {
                                                        case 'recover':
                                                            if (item.deleted) return link
                                                            break
                                                        case 'delete':
                                                            if (!item.deleted) return link
                                                            break
                                                    }
                                                } else {
                                                    return item.deleted? null: link
                                                }
                                                return null
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={2}>
                <Alert className="w-full" type={"info"}
                       title={<Trans>The category list is empty. Check filters or click on the Add button to add a new
                           category.</Trans>}/>
            </td>
        </tr>
    }

    return (
        <>
            {component}
        </>
    )
}
